<template>
  <div class="protocol loan-instruction-protocol">
    <div class="header">借款须知及风险提示</div>
    <instruction></instruction>
    <div class="header">借款合同</div>
    <loan></loan>
    <div class="header">委托扣款协议</div>
    <entrust></entrust>
    <authorization></authorization>
    <p
      data-sensors-exposure-property-page_status="page_bottom"
      data-sensors-exposure-event-name="general_event"
    >
      &nbsp;<!-- 监听协议滑动到了底部，每个协议都加上-->
    </p>
  </div>
</template>

<script>

export default {
  name: 'loan-instruction-protocol',
  components: {
    instruction: () => import('@/view/protocol/components/monitor-instruction.vue'),
    loan: () => import('@/view/protocol/components/loan.vue'),
    entrust: () => import('@/view/protocol/components/entrust.vue'),
    authorization: () => import('@/view/protocol/components/authorization.vue')
  },


  data () {
    return {}
  },
  created () {
    this.$bus.$emit('ready')
  },
  mounted () {},
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../../assets/less/mixin.less";

.loan-instruction-protocol {
  width: 100%;
  position: relative;

  .bolder {
    font-weight: bolder;
  }

  .text {
    text-indent: 40px;
  }

  .text:last-child {
    margin-bottom: 100px;
  }

  .tab-0 {
    text-indent: 0;
  }

  .underline {
    text-indent: 200px;
    font-weight: bold;
    text-decoration: underline;
  }

  .underline:last-child {
    margin-bottom: 100px;
  }
}
</style>
